import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import { style } from './text-group.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


export const textGroupAlignments = ['left', 'center', 'right'] as const
export type textGroupAlignmentsType = typeof textGroupAlignments

@customElement('cse-text-group')
export class CSETextGroup extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String, attribute: 'text-alignment' })
  textAlignment: textGroupAlignmentsType[number] = 'left'

  override render() {
    return html`
      <div
        class="${classMap({
          'cse-text-group': true,
          [`alignment-${this.textAlignment}`]: true,
        })}"
      >
        <div class="cse-text-group__heading">
          <slot name="overline"></slot>
          <slot name="heading"></slot>
          <slot name="subtitle"></slot>
        </div>
        <slot></slot>
      </div>
    `
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cse-text-group': CSETextGroup
  }
}
